<template>
  <div class="container-fluid mt-4">
    <b-card v-if="userIsLoggedIn">
      <b-card-header style="height: 75px;">
        <b-row>
          <b-col lg="9">
            <h1 class="h1">{{ dataConfig.title }}</h1>
          </b-col>
          <b-col lg="3">
            <b-alert style="margin-top: 5px;" :show="loading" variant="info">Lädt Daten...</b-alert>
          </b-col>
        </b-row>
      </b-card-header>
      <b-row>
        <b-col lg="12">
          <datatable :DataConfig="dataConfig" v-bind="$data" />
        </b-col>
        <b-col lg="6">
          <!--<b-alert :show="loading" variant="info">Lädt Daten...</b-alert>-->
          <b-card :title="dataConfig.title + ' über Datei hinzufügen'">
            <input style="padding-bottom: 10px;" type="file" ref="file" id="input"/>
            <b-btn v-on:click="loadTextFromFile">Vorschau laden</b-btn>
          </b-card>
          <b-alert style="margin: 5px;" :show="loading" variant="info">Lädt Daten...</b-alert>
        </b-col>
        <b-col v-if="showPreview" lg="12">
          <b-card :title="'Vorschau (max. 20 Zeilen)'">
            <b-btn v-on:click="submitFile(dataConfig.databaseName)">Daten hochladen</b-btn>
            <b-btn v-on:click="deleteDataPreview()">Daten verwerfen</b-btn>
            <div v-if="warnings.length" style="margin: 5px;">
              <p class="text-warning" v-for="(warn, ind) in warnings" :key="ind" v-html="warn" />
                <information
                  :info-text="`Mögliche Kategorien sind: ${headerLabels.join(', ')}`"
                />
            </div>
            <datatable
              :data="previewData.slice(0, 20)"
              :columns="previewColumns"
              :query="{ limit: 20, offset: 0, sort: 'option', order: 'ASC', freeTextFilters: {}, assocFilters: {} }"
              :total="previewData.length"
              :HeaderSettings="false"
              :Pagination="false"
              :Export="false"
            />
          </b-card>
        </b-col>
        <b-col lg="6">
          <akribes-form
            :dataConfig="dataConfig"
            :containsImages="false"
            :routeID="routeID"
          />
        </b-col>
      </b-row>
    </b-card>
    <div v-else>
      <NotLoggedIn v-if="!loading" />
    </div>
  </div>
</template>

<script>
import mixins from '../mixins/table_mixins'
import helpers from '@/mixins/helper-functions'
import api from '@/api'
import config from '../config.json'
import readXlsxFile from 'read-excel-file'
import NotLoggedIn from './NotLoggedIn'
import AkribesForm from './plugins/AkribesForm'

export default {
  name: 'show-data',
  components: {
    NotLoggedIn,
    FilterTh: () => import('./plugins/th-Filter'),
    'akribes-form': AkribesForm
  },
  mixins: [mixins],
  data () {
    return {
      columns: [],
      data: [],
      total: 0,
      query: { limit: 10, offset: 0, sort: 'option', order: 'ASC', freeTextFilters: {}, assocFilters: {}, nChanges: 0 },
      text: ''
    }
  },
  computed: {
    dbID () {
      return this.$route.params.db_id
    },
    dataConfig () {
      return config.tab_settings[this.dbID]
    },
    file () {
      return this.$refs.file
    },
    routeID () {
      return this.$route.params.id
    },
    LabelToDBKey () { // TO DO: Move this to helpers or similar
      var dict = {}
      this.dataConfig.tableHeader.forEach(head => {
        dict[head.label] = head.db_key
        dict[helpers.replaceSpecialLetters(head.label)] = head.db_key
      })
      return dict
    },
    headerLabels () {
      return this.dataConfig.tableHeader.map(head => head.label)
    }
  },
  methods: {
    async refreshPosts () {
      this.loading = true
      const config = this.dataConfig
      try {
        var response = await api.getPosts(config.databaseName, this.query)
      } catch (err) {
        this.loading = false
        return
      }
      if (typeof response === 'object') { // typeof response === 'string' if not logged in -> throws error
        var dbResult = response.result
        var columns = response.columns
        this.columns = config.tableHeader.map(function (header) {
          var isVisible = helpers.columnIsVisible(columns, header.db_key, header.visible)
          return {
            title: header.label,
            field: header.db_key,
            category: header.category,
            sortable: false,
            visible: isVisible,
            isChecked: isVisible,
            thComp: (header.db_key === 'option') ? 'FilterTh' : '',
            isFreeTextFilter: (header.label === 'Komorbiditäten')
          }
        })
        this.data = (config.databaseName === 'medication' && dbResult.rows) ? helpers.transformDBToTable(dbResult.rows) : dbResult.rows
        this.total = dbResult.count
      }
      this.loading = false
    },
    loadTextFromFile () {
      const input = this.file
      var that = this
      readXlsxFile(input.files[0]).then((rows) => {
        const headers = rows.shift().map(row => helpers.replaceSpecialLetters(row))
        var inputData = rows.map(function (row) {
          var rowObj = {}
          headers.forEach((head, idx) => {
            rowObj[that.LabelToDBKey[head]] = row[idx]
          })
          return rowObj
        })
        this.xlsxInput[this.dataSetName] = inputData
        this.createDataPreview(this.xlsxInput)
      })
    },
    getDbKey (label) {
      return this.dataConfig.tableHeader.find(head => head.label === label).db_key
    }
  },
  watch: {
    async dataConfig () {
      await this.refreshPosts()
      this.query = { limit: 10, offset: 0, sort: 'option', order: 'ASC', freeTextFilters: {}, assocFilters: {}, nChanges: 0 }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Properties.vue